import {
  DeleteTasksSUCCESS,
  GetTasksERROR,
  GetTasksLOADING,
  GetTasksLOADINGMORE,
  GetTasksSUCCESS,
  GetTasksAppendSUCCESS,
  PostTasksSUCCESS,
  start,
  UpdateTasksSUCCESS,
} from "./Task.types";
import axios from "axios";
import { toast } from "react-toastify";
import toastOptions from "../toastOptions";
import { translate, getStoredLocale, apiErrorMessage } from "../../i18n/translate";

const ENDPOINT = (orgId) => `${process.env.REACT_APP_APIURL}/v1/organizations/${orgId}/time-entries/`;

const authConfig = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const startTask = (payload) => (dispatch) => {
  dispatch({ type: start, payload: payload });
};
// page 1 replaces the list (initial load or filter change); page > 1 appends
// (infinite scroll), so each dispatches a different success type to keep
// the reducer's replace/append logic explicit rather than inferred.
export const getTasksApi = (orgId, token, page = 1, pageSize = process.env.REACT_APP_PAGE_SIZE) => async (dispatch) => {
  dispatch({ type: page === 1 ? GetTasksLOADING : GetTasksLOADINGMORE });
  try {
    const { data } = await axios.get(ENDPOINT(orgId), { ...authConfig(token), params: { page, pageSize } });
    dispatch({
      type: page === 1 ? GetTasksSUCCESS : GetTasksAppendSUCCESS,
      payload: data,
    });
    return data;
  } catch (e) {
    dispatch({
      type: GetTasksERROR,
    });
  }
};
// fetchLatestEntryDayApi resolves the caller's most recently logged time
// entry's day ("YYYY-MM-DD"), or null if they have none - doesn't touch the
// shared tasks list state (unlike getTasksApi), since it's just a lookup
// used by Reports.jsx to default its date range to the user's last logged
// activity instead of today's date (ai-instruct-63).
export const fetchLatestEntryDayApi = (orgId, token) => async () => {
  try {
    const { data } = await axios.get(ENDPOINT(orgId), { ...authConfig(token), params: { page: 1, pageSize: 1 } });
    return data.items?.[0]?.day ?? null;
  } catch (e) {
    return null;
  }
};

// Time record creation intentionally has no success toast: it fires every
// time the timer is stopped, which would be too noisy.
export const postTasksApi = (item, orgId, token) => async (dispatch) => {
  dispatch({ type: GetTasksLOADING });
  try {
    const { data } = await axios.post(ENDPOINT(orgId), item, authConfig(token));
    dispatch({ type: PostTasksSUCCESS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: GetTasksERROR });
    toast.error(apiErrorMessage(e, getStoredLocale()), toastOptions);
  }
};
export const deleteTasksApi = (id, orgId, token) => async (dispatch) => {
  dispatch({
    type: GetTasksLOADING,
  });
  try {
    await axios.delete(ENDPOINT(orgId) + id, authConfig(token));
    dispatch({ type: DeleteTasksSUCCESS, payload: id });
    toast.success(translate(getStoredLocale(), "toasts.timeRecordDeleted"), toastOptions);
  } catch (e) {
    dispatch({
      type: GetTasksERROR,
    });
    toast.error(apiErrorMessage(e, getStoredLocale()), toastOptions);
  }
};
export const updateTasksApi = (task, orgId, token) => async (dispatch) => {
  dispatch({
    type: GetTasksLOADING,
  });
  try {
    const { id } = task;
    const { data } = await axios.put(ENDPOINT(orgId) + id, task, authConfig(token));
    dispatch({ type: UpdateTasksSUCCESS, payload: data });
    toast.success(translate(getStoredLocale(), "toasts.timeRecordUpdated"), toastOptions);
  } catch (e) {
    dispatch({
      type: GetTasksERROR,
    });
    toast.error(apiErrorMessage(e, getStoredLocale()), toastOptions);
  }
};
